import { createPortal } from 'react-dom';
import { Button } from './ui';

type Instagram2FAHelpModalProps = {
  onClose: () => void;
};

/**
 * Everything the connect card deliberately does not say inline.
 *
 * The card is three short steps; the detail that would bloat it lives here —
 * the risk notice (which used to sit permanently above the form, where it
 * scared people without telling them what to do), and the manual-publishing
 * escape hatch, which is the reassurance that makes the risk notice bearable.
 */
export function Instagram2FAHelpModal({ onClose }: Instagram2FAHelpModalProps) {
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal settings-instagram-help-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-header">
          <h2>Instagram setup</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close dialog">
            ×
          </button>
        </div>

        <div className="modal-body settings-instagram-help-modal__body">
          <ol className="settings-instagram-help-modal__steps">
            <li>
              <strong>Use a dedicated account</strong>
              <span>Not your personal one. A business or normal account both work.</span>
            </li>
            <li>
              <strong>Turn on 2FA with an authenticator app</strong>
              <span>
                Google Authenticator, Microsoft Authenticator or Authy. Much steadier
                than SMS — keep your backup codes somewhere safe.
              </span>
            </li>
            <li>
              <strong>Set the region to where the account logs in</strong>
              <span>Posts publish from an IP address there, so matching it keeps things calm.</span>
            </li>
          </ol>

          <p className="settings-instagram-help-modal__note">
            <strong>Worth knowing.</strong> Instagram can challenge or restrict any
            automated account, and we cannot promise this always works — which is why a
            dedicated account is safest. Your other accounts are untouched.
          </p>

          <p className="settings-instagram-help-modal__lead">
            <strong>You are never stuck.</strong> Every post can be downloaded from
            Conistra and uploaded by hand in the Instagram app, whether or not this
            connection is working.
          </p>
        </div>

        <div className="modal-footer">
          <Button variant="primary" size="sm" onClick={onClose}>
            Got it
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
